/**
 * 艺术字动画
 * 2019-4-22
 */

(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    // CommonJS
    module.exports = factory(this);
  } else {
    //  全局变量
    factory(root);
  }
})(this, function (root) {
  var methods =  {
    getThreeD(color, size) {
      if(!color) color = '#FFFFFF';
      let Dvalue = [50, 3, 15, 3, 15, 3, 15];
      let arrC = this._hex2rgb(color);
      let textShadow = '';

      for (let i = 0; i < 5; i++) {
        arrC.forEach((val, index, arr) => {
          arr[index] -= Dvalue[i]
          arr[index] < 0 && (arr[index] = 0);
        });
        textShadow += `0 ${i+1}px 0 ${this._rgb2hex(arrC)},`
      }

      textShadow += '0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15)'
      return {
        color: color,
        textShadow: textShadow
      }
    },
    getInset(color, size) {
      if(!color) color = '#666666';
      return {
        backgroundColor: color,
        color: 'transparent',
        textShadow: 'rgba(255,255,255,0.5) 0px 3px 3px'
      }
    },
    getDropCenter(color, size = 100) {
      if(!color) color = '#FFFFFF';
      return {
        color: color,
        textShadow: `0 0 ${Math.round(size * 18 / 100)}px rgba(0,0,0,.35)`
      }
    },
    getPopUp(color, size) {
      if(!color) color = '#FFFFFF';
      let Kratio = [9/100, 50/100, 30/100],
          textShadow = '',
          arrC = this._hex2rgb(color),
          newColor;

      arrC.forEach((val, index, arr) => {
          arr[index] -= 50
          arr[index] < 0 && (arr[index] = 0);
      });
      newColor = this._rgb2hex(arrC)
      for(let i = 0; i < Math.round(size * Kratio[0]); i++) {
        textShadow += `0 ${i + 1}px 0 ${newColor},`;
      }
      textShadow += `0 ${Math.round(size * Kratio[1])}px ${Math.round(size * Kratio[2])}px rgba(0,0,0,.3)`;
      return {
        color: color,
        textShadow: textShadow
      }
    },
    getPopLeft(color, size) {
      if(!color) color = '#FFFFFF';
      let Kratio = 8 / 100,
          textShadow = '';
      for(let i = 0; i < Math.round(size * Kratio); i++) {
        textShadow += `-${i + 1}px 0 0 #555,`;
      }
      return {
        color: color,
        textShadow: textShadow.slice(0,-1)
      }
    },
    getPopRight(color, size) {
      if(!color) color = '#FFFFFF';
      let Kratio = 8 / 100,
          textShadow = '';
      for(let i = 0; i < Math.round(size * Kratio); i++) {
        textShadow += `${i + 1}px 0 0 #555,`;
      }
      return {
        color: color,
        textShadow: textShadow.slice(0,-1)
      }
    },
    getFlatSimple(color, size=100) {
      if(!color) color = '#F1EBE5';
      let Dvalue = [45, 54, 72];
      let arrC = this._hex2rgb(color);
      arrC.forEach((val, index, arr) => {
        arr[index] -= Dvalue[index]
        arr[index] < 0 && (arr[index] = 0);
      });
      return {
        color: color,
        textShadow: `0 ${Math.round(size * 13.36 / 100)}px ${Math.round(size * 8.896 / 100)}px ${this._rgb2hex(arrC)}, 0 -2px 1px #fff`,
      }
    },
    getGlitch(color, size) {
      if(!color) color = '#000000'
      return {
        color: color
      }
    },
    getGlitchRed(color, size) {
      if(!color) color = '#000000'
      return {
        color: color
      }
    },
    getGradenGoldenrod(color, size) {
      let col = ['goldenrod', 'orangered', 'mediumblue', 'purple'];
      if(!color) color = '#FFFF00'
      return this._getGraden(size, col, color)
    },
    getGradenPink(color, size) {
      let col = ['pink', 'orangered', 'red', 'magenta'];
      if(!color) color = '#FFB6C1'
      return this._getGraden(size, col, color)
    },
    getGradenAzure(color, size) {
      let col = ['azure', 'aqua', 'dodgerblue', 'blue'];
      if(!color) color = '#F0FFFF'
      return this._getGraden(size, col, color)
    },
    getGradenTomato(color, size) {
      let col = ['orangered', 'firebrick', 'maroon', 'darkred'];
      if(!color) color = '#FF6347'
      return this._getGraden(size, col, color)
    },
    getGradenYellow(color, size) {
      let col = ['yellow', 'lime', 'green', 'darkgreen'];
      if(!color) color = '#FFFF00'
      return this._getGraden(size, col, color)
    },
    getGradenLightyellow(color, size) {
      let col = ['yellow', 'gold', 'orange', 'darkred'];
      if(!color) color = '#FFFFE0'
      return this._getGraden(size, col, color)
    },
    _getGraden(size, col, color) {
      let basis = Math.round(10 / 100 * size);
      return {
        textShadow: `0 0 ${basis}px ${col[0]}, 0 0 ${basis*2}px ${col[1]}, 0 0 ${basis*4}px ${col[2]}, 0 0 ${basis*8}px ${col[3]}`,
        // filter: 'saturate(60%)',
        color: color
      }
    },
    _hex2rgb: function(hex = '#fff') {
      var arr = [];
      hex = hex.toLowerCase();
      if(hex.length === 4) {
        var shex = '#';
        for(var i=1; i<4; i+=1){  
          shex += hex.slice(i,i+1).concat(hex.slice(i,i+1));     
        }  
        hex = shex;  
      }
      for(var i=1; i<7; i+=2) {
        arr.push(parseInt("0x" + hex.slice(i, i+2)));
      }
      return arr
    },
    _rgb2hex: function(arr) {
      return "#" + ((1 << 24) + (arr[0] << 16) + (arr[1] << 8) + arr[2] << 0).toString(16).slice(1);
    },
  }

  function getArtStyle(artType, color, size) {
    if(!artType) return;
    return methods['get' + artType](color, size)
  }

  if (root.AnimEditor) {
    root.AnimEditor.getArtStyle = getArtStyle;
    return;
  }

  return function (AnimEditor) {
    AnimEditor.getArtStyle = getArtStyle;
  }
})


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/art-effects/artStyle.js
// module id = FBtK
// module chunks = 16